import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/images/logo/alba.png'
import _imports_1 from '../../assets/images/logo/authalba2.png'


const _hoisted_1 = { class: "columns" }
const _hoisted_2 = {
  key: 0,
  class: "column is-4 friProfileCol1"
}
const _hoisted_3 = { class: "account-box is-navigation p-0 border-none" }
const _hoisted_4 = { class: "account-menu" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-user-alt"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-power fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Cerrar sesión")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "form-head-inner text-left" }
const _hoisted_13 = { class: "left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "150"
  })
], -1)
const _hoisted_15 = {
  key: 0,
  class: "fieldset ps-0"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "d-flex justify-content-center align-items-center my-2" }
const _hoisted_19 = { class: "friUserCircle2 friBack1 text-white" }
const _hoisted_20 = {
  key: 0,
  class: "text-center mt-5 fs-5"
}
const _hoisted_21 = {
  key: 1,
  class: "text-center mt-5 fs-5"
}
const _hoisted_22 = {
  key: 2,
  class: "text-center mt-5 fs-5"
}
const _hoisted_23 = { class: "fieldset-heading mb-0 mx-4" }
const _hoisted_24 = { class: "d-flex justify-content-center align-items-center fs-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-center fs-1 mt-5" }, "Notificaciones", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-2 mb-3 mx-5" }, " Conecte con sus dispositivos para recibir notificaciones de alarma en tiempo real. ", -1)
const _hoisted_27 = {
  key: 0,
  class: "fieldset-heading mb-0 mt-3 mx-5"
}
const _hoisted_28 = {
  key: 0,
  class: "pt-2 text-center friColor4 text-xs3"
}
const _hoisted_29 = {
  key: 0,
  class: "pt-2 text-center friColor4 text-xs3"
}
const _hoisted_30 = {
  key: 0,
  class: "pt-2 text-center friColor4 text-xs3"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 ps-2" }, [
  /*#__PURE__*/_createTextVNode("Acepto los "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.fricontrolalba.com/legal",
    target: "_blank",
    class: "friColor1"
  }, "Términos y condiciones *")
], -1)
const _hoisted_32 = { class: "d-flex justify-content-center align-items-center fs-5" }
const _hoisted_33 = {
  key: 4,
  class: "text-center mt-5 px-5 mx-5 friColor3"
}
const _hoisted_34 = { class: "p-0" }
const _hoisted_35 = { class: "text-left" }
const _hoisted_36 = {
  class: "w-25 inline-block text-center",
  style: {"max-width":"150px"}
}
const _hoisted_37 = { class: "w-50 inline-block align-top text-left" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5" }, "Alba Hub", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Plan basic", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "text-success text-sm" }, "Activa", -1)
const _hoisted_41 = [
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "w-25 inline-block align-top text-right mt-1" }
const _hoisted_43 = {
  key: 0,
  class: "my-5",
  style: {"border-top":"1px solid #ddd"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_IonSelectOption = _resolveComponent("IonSelectOption")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["account-wrapper text-left", !_ctx.isMobile ? 'mt-5' : ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.sections, (section, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["account-menu-item cursor-pointer", _ctx.layout.section == section.name ? 'router-link-active router-link-exact-active' : '']),
                      onClick: ($event: any) => (_ctx.layout.section = section.name)
                    }, [
                      _hoisted_6,
                      _createElementVNode("span", null, [
                        _createElementVNode("i", {
                          class: _normalizeClass(section.icon + ' fs-3 align-middle me-3')
                        }, null, 2),
                        _createTextVNode(_toDisplayString(section.title), 1)
                      ]),
                      _hoisted_7
                    ], 10, _hoisted_5))
                  }), 128)),
                  _createElementVNode("div", {
                    class: "account-menu-item mt-2 cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logoutApp()))
                  }, _hoisted_11)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["column is-8", _ctx.isMobile ? 'px-0' : '']),
          id: "friProfileCol2"
        }, [
          _createElementVNode("div", {
            class: "account-box is-form is-footerless p-0 m-0",
            style: _normalizeStyle(_ctx.isMobile ? 'border-bottom: none !important;' : '')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-head stuck-header", _ctx.isMobile ? 'py-0' : 'py-3'])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h4", {
                    class: _normalizeClass(["fw-bold", _ctx.isMobile ? 'fs-3 my-5 ms-2' : 'fs-4'])
                  }, "Mi cuenta ", 2)
                ]),
                _hoisted_14
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-body profilePage px-0 mx-5", _ctx.isMobile ? 'pt-0' : ''])
            }, [
              (_ctx.layout.section == 'profile')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_ctx.profile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_ctx.profile.first)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.profile.first[0]) + _toDisplayString(_ctx.profile.last[0]), 1)
                                ]),
                                (_ctx.profile.isClient)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Cliente"))
                                  : (_ctx.profile.isAgent)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Agente"))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_22, "Usuario"))
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_list, { class: "mt-0 pt-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                class: "border-none",
                                style: {"--ion-item-border-color":"#ccc"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    position: "floating",
                                    class: "friColor1 fs-6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Nombre *")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.profile.first,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.first) = $event)),
                                    type: "text",
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                style: {"--ion-item-border-color":"#ccc"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, {
                                    position: "floating",
                                    class: "friColor1 fs-6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Apellidos *")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_input, {
                                    modelValue: _ctx.profile.last,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile.last) = $event)),
                                    type: "text",
                                    autocomplete: "off"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (_ctx.profile.isClient)
                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                    key: 0,
                                    lines: "full",
                                    style: {"--ion-item-border-color":"#ccc"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        position: "floating",
                                        class: "friColor1 fs-6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Documento *")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_input, {
                                        modelValue: _ctx.profile.document,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.profile.document) = $event)),
                                        type: "text",
                                        autocomplete: "off"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.profile.isRoot)
                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                    key: 1,
                                    lines: "full",
                                    class: "border-none",
                                    style: {"--ion-item-border-color":"#ccc"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, {
                                        position: "floating",
                                        class: "friColor1 fs-6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Rol")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_select, {
                                        interface: "popover",
                                        placeholder: "Rol",
                                        modelValue: _ctx.profile.role,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profile.role) = $event)),
                                        class: "friColor1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_IonSelectOption, { value: "superadmin" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Superadmin")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_IonSelectOption, { value: "admin" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Admin")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_IonSelectOption, { value: "client" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Client")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", {
                              class: "inline-block align-top fs-6 mt-4 friBack9 br-5 text-dark px-5 py-2 me-1 cursor-pointer",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePass()))
                            }, "Modificar contraseña")
                          ]),
                          _createElementVNode("div", {
                            style: _normalizeStyle(_ctx.isMobile ? 'margin-top: 50px; margin-bottom: 30px;' : 'margin-top: 40px;')
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", {
                                class: "friBtn1 br-5 cursor-pointer",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveProfile()))
                              }, "GUARDAR")
                            ])
                          ], 4)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.layout.section == 'notify')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_25,
                    _hoisted_26,
                    (_ctx.profile.notify)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_ctx.layout.notify.email)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  style: {"--ion-item-border-color":"#ccc"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      position: "floating",
                                      class: "friColor1 fs-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Email")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.profile.notify.email,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.profile.notify.email) = $event)),
                                      type: "email",
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.profile.notify.email)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, "No recibirá notificaciones de alarma por email."))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.layout.notify.whatsapp)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  class: "border-none mt-2 pt-0",
                                  style: {"--ion-item-border-color":"#ccc"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      position: "floating",
                                      class: "friColor1 mt-0 pt-0 fs-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Número de WhatsApp")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.profile.notify.whatsapp,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.profile.notify.whatsapp) = $event)),
                                      type: "tel",
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.profile.notify.whatsapp)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, "No recibirá notificaciones de alarma por Whatsapp."))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.layout.notify.sms)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  class: "border-none mt-2",
                                  style: {"--ion-item-border-color":"#ccc"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      position: "floating",
                                      class: "friColor1 fs-6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Número SMS")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.profile.notify.sms,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.profile.notify.sms) = $event)),
                                      type: "tel",
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (!_ctx.profile.notify.sms)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_30, "No recibirá notificaciones de alarma por SMS."))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.layout.notify.email || _ctx.layout.notify.whatsapp || _ctx.layout.notify.sms)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  class: "border-none mt-5 mb-5",
                                  style: {"--ion-item-border-color":"#fff"},
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.layout.terms = true;})
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_checkbox, {
                                      slot: "start",
                                      class: "border-none p-0 m-0 friBorder3",
                                      color: "primary",
                                      modelValue: _ctx.layout.acceptTerms,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.layout.acceptTerms) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_31
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", {
                                  style: _normalizeStyle(_ctx.isMobile ? 'margin-top: 20px; margin-bottom: 30px;' : 'margin-top: 30px; margin-bottom: 30px;')
                                }, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", {
                                      class: "friBtn1 br-5 cursor-pointer",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveNotify()))
                                    }, "GUARDAR")
                                  ])
                                ], 4)
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_33, "No dispone de dispositivos asociados para recibir notificaciones de alarma."))
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.layout.section == 'subscription')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-left p-0 m-0 cursor-pointer mb-2", _ctx.isMobile ? 'mt-5 ' : ''])
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("img", {
                              src: _imports_1,
                              style: _normalizeStyle(_ctx.isMobile ? 'width: 90%; padding-left: 10px;' : 'width: 50%')
                            }, null, 4)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["ps-0 ms-1", _ctx.isMobile ? 'ps-3' : 'mt-1'])
                            }, _hoisted_41, 2)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["bi bi-arrow-right-circle text-gray-light", _ctx.isMobile ? ' me-3' : '']),
                              style: {"font-size":"45px"}
                            }, null, 2)
                          ])
                        ])
                      ])
                    ], 2),
                    (_ctx.isMobile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 2)
          ], 4)
        ], 2)
      ])
    ], 2)
  ]))
}